exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-view-wrapper .tags-view-item .el-icon-close {\n  width: 0.083333rem;\n  height: 0.083333rem;\n  vertical-align: 0.010417rem;\n  border-radius: 50%;\n  text-align: center;\n  transition: all .3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transform-origin: 100% 50%;\n}\n.tags-view-wrapper .tags-view-item .el-icon-close:before {\n  transform: scale(0.6);\n  display: inline-block;\n  vertical-align: -0.015625rem;\n}\n.tags-view-wrapper .tags-view-item .el-icon-close:hover {\n  background-color: #b4bccc;\n  color: #fff;\n}", ""]);

// exports
